import { riskDisclosure } from '../data/content';
import Disclosure from './Disclosure';

export default function RiskDisclosure({ title = 'Risk Disclosure' }) {
  return (
    <Disclosure title={title} defaultOpen>
      <p className="text-xs leading-relaxed text-slate-600">{riskDisclosure}</p>
    </Disclosure>
  );
}
